import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {message, Tooltip} from 'antd'
import {generatePrintOrder} from "../../../../../services/api/3dApi"

class GenerateTemplate extends Component {

    _handleClick = e => {
        e.preventDefault()

        this._generateTemplate()
    }

    _generateTemplate = async () => {
        try {
            const {orderId} = this.props

            const {data: response} = await generatePrintOrder(orderId)

            const {success, error} = response

            if (!success) {
                throw new Error(error)
            }

            this.props.onChangeStatus('retry')
        } catch (e) {
            message.error(e.message, 3)
        }
    }

    render() {
        return (
            <div className='GenerateTemplate Icon' onClick={this._handleClick}>
                <Tooltip title='Tạo file in' placement='bottom'>
                    <i className='fa fa-share-square-o'/>
                </Tooltip>
            </div>
        )
    }
}

GenerateTemplate.propTypes = {
    orderId: PropTypes.string.isRequired,
    onChangeStatus: PropTypes.func.isRequired,
}

export default GenerateTemplate
